import React from "react";
import PropTypes from "prop-types";

import Modal from "components/Modal";

import { useReactivateUser } from "./hooks";
import { useUserManagementModalStyles } from "../AddUserModal/AddUserModal";
import SubscriptionInformationPage from "../AddUserModal/components/SubscriptionInformationPage";

function ReactivateUserModal({ reactivatedUserId, onReactivated, onClose }) {
  const classes = useUserManagementModalStyles();
  const { onSubmit, loading } = useReactivateUser(
    reactivatedUserId,
    onReactivated
  );

  return (
    <Modal
      data-test="reactivate-users-modal"
      className={classes.modal}
      size="large"
      isModalOpen
      onClose={onClose}
    >
      <SubscriptionInformationPage
        inviteCount={1}
        loading={loading}
        onSubmit={onSubmit}
        onClose={onClose}
      />
    </Modal>
  );
}

ReactivateUserModal.propTypes = {
  reactivatedUserId: PropTypes.string.isRequired,
  onReactivated: PropTypes.func,
  onClose: PropTypes.func,
};

ReactivateUserModal.defaultProps = {
  onReactivated: () => {},
  onClose: () => {},
};

export default ReactivateUserModal;
